import {Button, Modal, theme, Typography} from 'antd';
import React from 'react';

interface IProps {
  isOpen: boolean;
  toggleDialog: any;
  text: any;
}

// This alert only ever has one real action available to it — dismiss (there's
// no onConfirm/onDelete prop wired in by any of its callers) — so unlike the
// two-button "Delete draft SR?" example in the AST Console Revamp mockup, its
// footer stays a single dismiss button rather than a fabricated danger action.
const SimpleAlert: React.FC<IProps> = (props) => {
  const {isOpen, toggleDialog, text} = props;
  const {token}: any = theme.useToken();

  return (
    <Modal
      // Unmount content on close, as the old MUI Dialog did, so each open starts fresh.
      destroyOnHidden
      open={isOpen}
      onCancel={toggleDialog}
      centered
      title={
        <Typography.Title level={4} style={{margin: 0, color: token.colorPrimary}}>
          {text.heading}
        </Typography.Title>
      }
      footer={
        <Button type="primary" onClick={toggleDialog}>
          Got it
        </Button>
      }>
      <Typography.Text style={{color: token.colorTextSecondary, display: 'block'}}>
        <div style={{textAlign: 'center'}}>{text.subtitle}</div>
      </Typography.Text>
    </Modal>
  );
};

export default SimpleAlert;
